import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../Layout";
import clsx from "clsx";
import { Typography } from "@mui/material";
import back from "../../assets/img/back.svg";
import useLoggedIn from "../../hooks/useLoggedIn";
import TabPane from "@components/TabPane";
import GroupPreferredTags from "./GroupPreferredTags";
import GroupRestrictedTags from "./GroupRestrictedTags";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import GroupPublicTagsPage from "./GroupPublicTagsPage";
import { useTheme } from "@emotion/react";
// import backImg from '../assets/img/back.svg';
import { useNavigate } from "react-router-dom";
import Title from "../../components/Title";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  textGrey: {
    color: "#626262",
  },
  colorGreen: {
    backgroundColor: "#e5f8f1",
  },
}));

function GroupTagManagement({
  group,
  getGroup,
  onClose,
  noLayout = false,
  readOnly = false,
}) {
  useLoggedIn();
  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();
  const { userRecord } = useSelector((state) => state.user);

  const tabs = ["Group Topics", "Blocked Topics"];

  const [activeTab, setActiveTab] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const onTabChange = (index) => {
    if (index >= 0 && index < tabs.length) setActiveTab(index);
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  const userIsAdmin = userRecord?.id === group?.admin?.id;

  // If explicitly readOnly (from parent) or user is not admin, show public/view-only tags page
  if (readOnly || !userIsAdmin) {
    const publicContent = (
      <div>
        <Title
          onBack={() =>
            typeof onClose === "function" ? onClose() : navigate(-1)
          }
        >
          Group Topics
        </Title>
        <GroupPublicTagsPage group={group} />
      </div>
    );

    return noLayout ? publicContent : <Layout>{publicContent}</Layout>;
  }

  const content = (
    <div>
      <Title
        onBack={() =>
          typeof onClose === "function" ? onClose() : navigate(-1)
        }
      >
        Add Topics
      </Title>
      <TabPane
        unfixed
        centered={windowWidth >= 640}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
      >
        <GroupPreferredTags group={group} getGroup={getGroup} />
        <GroupRestrictedTags group={group} getGroup={getGroup} />
      </TabPane>
    </div>
  );

  return noLayout ? content : <Layout>{content}</Layout>;
}

export default GroupTagManagement;
